import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6a7b546"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-bar-custom full navbar navbar-expand-lg navbar-light" }
const _hoisted_2 = { class: "container-fluid full" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  id: "nav-bar-icon",
  class: "navbar-toggler-icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "list-group-item divider full",
  role: "separator"
}, null, -1))

import { useRouter, useRoute } from 'vue-router'
import { onMounted, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBar',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const activeRoute = ref<{ path: string; title: string }>()
const rightRoutes = ref<{ path: string; title: string }[]>([])
const leftRoutes = ref<{ path: string; title: string }[]>([])
const menuOpen = ref<boolean>(false)

const toggleMenu = () => (menuOpen.value = !menuOpen.value)
const closeMenu = () => (menuOpen.value = false)

const pathIsActive = (path: string) => path === activeRoute.value?.path

watch(
  () => route.path,
  (path) => {
    activeRoute.value =
      leftRoutes.value.find((route) => route.path === path) ||
      rightRoutes.value.find((route) => route.path === path)
  }
)

onMounted(async () => {
  await router?.isReady()
  const filteredRoutes = router
    ?.getRoutes()
    ?.filter(
      (route) => route?.meta && route?.meta?.title && !route?.meta?.hidden
    )

  leftRoutes.value = filteredRoutes
    ?.filter(
      (route) => route?.meta && !route?.meta?.right && !route?.meta?.hidden
    )
    ?.map((route) => ({
      path: (route.path || '') as string,
      title: (route?.meta?.title || '') as string,
    }))

  rightRoutes.value = filteredRoutes
    ?.filter(
      (route) => route?.meta && route?.meta?.right && !route?.meta?.hidden
    )
    ?.map((route) => ({
      path: (route.path || '') as string,
      title: (route?.meta?.title || '') as string,
    }))
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#navBarMenu",
        "aria-controls": "navBarMenu",
        "aria-expanded": "false",
        "aria-label": "Toggle nav",
        onClick: toggleMenu
      }, _hoisted_4),
      _createElementVNode("div", {
        id: "navBarMenu",
        class: _normalizeClass(["collapse navbar-collapse full", { 'd-flex py-1': menuOpen.value }])
      }, [
        _createElementVNode("ul", {
          class: _normalizeClass(["navbar-nav navbar-full-menu list-group full", { 'navbar-menu-custom': menuOpen.value }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftRoutes.value, (r) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item list-group-item fit",
              key: r.title
            }, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["nav-link", { active: _unref(route).path === r.path }]),
                to: r.path ? r.path : '#',
                routerLinkActive: pathIsActive(r.path),
                onClick: closeMenu
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(r.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to", "routerLinkActive"])
            ]))
          }), 128)),
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightRoutes.value, (r) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item list-group-item fit",
              key: r.title
            }, [
              _createVNode(_component_router_link, {
                class: _normalizeClass(["nav-link float-md-end", { active: _unref(route).path === r.path }]),
                to: r.path ? r.path : '#',
                routerLinkActive: pathIsActive(r.path),
                onClick: closeMenu
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(r.title), 1)
                ]),
                _: 2
              }, 1032, ["class", "to", "routerLinkActive"])
            ]))
          }), 128))
        ], 2)
      ], 2)
    ])
  ]))
}
}

})